import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function BiancaOlliverPage() {
  return <AttorneyBioTemplate attorney={attorneys['bianca-olliver-esq']} />;
}
